<script setup lang="ts">
    import { ref, toRef } from 'vue'
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import ChartBox from '@/js/components/Chart/ChartBox.vue'
    import { useSemester } from '@/js/composables/useSemester'
    import type { Kennzahl, DashboardValue } from '@/js/composables/chart/types'

    const props = defineProps<{
        dashboardData: DashboardValue[]
        yearsToDisplay: number
    }>()

    const { dashboardDataYears } = useSemester(toRef(props, 'dashboardData'), toRef(props, 'yearsToDisplay'))

    const kennzahlen = ref<Kennzahl[]>([
        {
            kennzahlId: '4.1.',
            kennzahlTitle: 'Anzahl aller Absolvent*innen',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Absolvent*innen'
        },
        {
            kennzahlId: '4.1.1.',
            kennzahlTitle: 'Anzahl an Absolvent*innen in Regelstudienzeit + 2 Semester',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Absolvent*innen'
        },
        {
            kennzahlId: '4.1.2.',
            kennzahlTitle: 'Anzahl der Abbrecher*innen im Studiengang',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Absolvent*innen'
        },
        {
            kennzahlId: '4.2.',
            kennzahlTitle: 'Durchschnittliche Studiendauer',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Studiendauer in Jahren'
        }
    ])
</script>

<template>
    <ContentCollapse collapse-key="collapse-dashboard-ziel-4" title="4. Studienerfolg" is-visible-by-default>
        <div class="d-flex flex-wrap p-4 justify-space-between ga-1">
            <ChartBox
                v-for="(kennzahl, key) in kennzahlen"
                :key="kennzahl.kennzahlId"
                :kennzahl="kennzahl"
                :dashboard-data="dashboardData"
                :dashboard-data-years="dashboardDataYears"
                storage-key=""
                :box-size="350"
                :show-title="true"
                :show-target-value="false"
                :center-box="kennzahlen.length === 2 && key === 1"
            />
        </div>
    </ContentCollapse>
</template>

<style scoped></style>
